export const OBJECT_HOVER_RED = '#FC8181';
export const OBJECT_EDIT_RED = '#E53E3E';
export const OBJECT_SELECT_BLUE = '#55AAFF';

export const OBJECT_EDIT_YELLOW = '#FFD400';
